/** KPI figures computed from the currently visible (filtered) demo rows. */
export function computeStats(rows = []) {
  const approved = rows.filter((d) => d.status === 'approved');
  const byOutcome = (r) => approved.filter((d) => d.outcome?.result === r).length;
  const admissions = byOutcome('admission');
  const alignment = { aligned: 0, partial: 0, contradictory: 0 };
  approved.forEach((d) => { if (alignment[d.feedback_alignment] !== undefined) alignment[d.feedback_alignment] += 1; });
  return {
    total_demos: rows.length,
    total_approved: approved.length,
    admissions,
    no_admissions: byOutcome('no_admission'),
    followups: byOutcome('follow_up'),
    conversion_pct: approved.length ? Math.round((admissions / approved.length) * 1000) / 10 : 0,
    pending_approval: rows.filter((d) => d.status === 'pending_approval').length,
    pending_feedback: approved.filter((d) => !(d.trainer_feedback && d.counsellor_feedback)).length,
    finalised: rows.filter((d) => d.finalised).length,
    alignment,
  };
}

/** Group rows by a key for the report rollups. */
export function rollup(rows, keyField) {
  const m = {};
  rows.forEach((d) => {
    const name = d[keyField] || '—';
    const e = m[name] || (m[name] = { name, demos: 0, admissions: 0, no_admissions: 0, followups: 0, mismatch: 0, pending: 0 });
    e.demos += 1;
    const res = d.outcome?.result;
    if (res === 'admission') e.admissions += 1;
    if (res === 'no_admission') e.no_admissions += 1;
    if (res === 'follow_up') e.followups += 1;
    if (!res) e.pending += 1;
    if (d.feedback_alignment === 'contradictory') e.mismatch += 1;
  });
  return Object.values(m).map((e) => ({ ...e, conversion: e.demos ? Math.round((e.admissions / e.demos) * 100) : 0 }))
    .sort((a, b) => b.demos - a.demos);
}
